{
	"title": "Athlete manager",
	"subtitle": "Why an athlete is not on an OVR start list: each athlete card, its shortlist and its entries in {{games}}.",
	"chain": "An athlete reaches a start list in three steps: an approved athlete card in GMS → shortlisted for the event → entered in OVR. In an individual event, shortlisting enters the athlete by itself.",
	"filters": {
		"label": "Athlete manager filters",
		"name": "Name or card number",
		"noc": "NOC",
		"allNocs": "Every NOC",
		"sport": "Sport",
		"allSports": "Every sport",
		"problem": "Problem",
		"anyProblem": "Every athlete",
		"withProblem": "With any problem"
	},
	"problems": {
		"NOT_APPROVED": "Card not approved",
		"NO_SPORT": "No sport on the card",
		"NOT_SHORTLISTED": "Not shortlisted",
		"SHORTLISTED_NOT_ENTERED": "Shortlisted, not entered",
		"ENTERED_NOT_SHORTLISTED": "Entered, not shortlisted",
		"START_LIST_NOT_SHORTLISTED": "On a start list, no longer shortlisted",
		"NO_SPORT_CLASS": "No sport class"
	},
	"problemHint": {
		"NOT_APPROVED": "Approve the card in GMS first.",
		"NO_SPORT": "Give the card a sport in GMS.",
		"NOT_SHORTLISTED": "Shortlist the athlete for their events.",
		"SHORTLISTED_NOT_ENTERED": "Put the athlete in a team for this event.",
		"ENTERED_NOT_SHORTLISTED": "Shortlist the athlete for the event they are entered in.",
		"START_LIST_NOT_SHORTLISTED": "The NOC took the athlete off the shortlist (or the card is no longer approved), but they are already on a start list, so the entry stayed. Take them off the start list and withdraw the entry, or shortlist them again.",
		"NO_SPORT_CLASS": "Record the athlete's classification in GMS."
	},
	"gender": {
		"MALE": "Male",
		"FEMALE": "Female"
	},
	"row": {
		"allSports": "Every sport",
		"noSport": "No sport",
		"noEvents": "Not shortlisted or entered in any event.",
		"moreEvents_one": "and {{count}} more event",
		"moreEvents_other": "and {{count}} more events",
		"noProblems": "On the start lists",
		"cardStatus": "Card {{status}}",
		"events": "Events",
		"problems": "Problems"
	},
	"shortlist": {
		"PRIMARY": "Primary",
		"RESERVE": "Reserve",
		"none": "Not shortlisted"
	},
	"entry": {
		"entered": "Entered",
		"ENTERED": "Entered",
		"WITHDRAWN": "Withdrawn",
		"DISQUALIFIED": "Disqualified",
		"none": "Not entered",
		"asRole": "as {{role}}"
	},
	"actions": {
		"enter": "Enter in event",
		"shortlist": "Shortlist",
		"teams": "Open teams",
		"openGms": "Open in GMS",
		"shortlistGms": "Shortlist for {{sport}} in GMS",
		"opensInNewTab": "Opens GMS in a new tab"
	},
	"confirm": {
		"enterTitle": "Enter {{name}} in {{event}}?",
		"enterBody": "A new entry is created for {{noc}} with {{name}} as its athlete.",
		"shortlistTitle": "Shortlist {{name}} for {{event}}?",
		"shortlistBody": "{{name}} is shortlisted as Primary for this event. The NOC's quota and final lock still apply."
	},
	"done": {
		"entered": "{{name}} is entered in {{event}}.",
		"shortlisted": "{{name}} is shortlisted for {{event}}.",
		"unchanged": "Nothing changed: {{name}} was already shortlisted."
	},
	"refused": {
		"title": "Not shortlisted",
		"not_in_scope": "This organisation is outside your scope.",
		"not_eligible": "The athlete is not eligible for this event.",
		"quota_full": "The NOC's quota for this event is full ({{used}} of {{limit}}).",
		"deadline_passed": "The NOC's shortlist deadline has passed. Only an administrator can change it now.",
		"entered": "The athlete is entered in this event.",
		"mark_required": "This event has a qualifying standard: enter the athlete's best record in the GMS shortlist first.",
		"below_standard": "The athlete's best record does not meet this event's qualifying standard."
	},
	"table": {
		"count_one": "{{n}} athlete",
		"count_other": "{{n}} athletes"
	},
	"empty": {
		"promptTitle": "Find an athlete",
		"promptBody": "Search a name or card number, or pick an NOC or a sport, then press Filter.",
		"noneTitle": "No athletes match",
		"noneBody": "Try another name, NOC, sport or problem.",
		"reset": "Reset filters",
		"noGamesTitle": "No games yet",
		"noGamesBody": "Create a games in GMS first.",
		"forbiddenTitle": "Admins only",
		"forbiddenBody": "The athlete manager is for ADMIN and SUPER_ADMIN. Switch role to use it.",
		"errorTitle": "Couldn't load the athletes"
	},
	"errors": {
		"gamesTitle": "Couldn't load the games"
	}
}
